import { Carousel } from "antd"
import useUrl from "hooks/useUrl"

type CarouselCconfig = {
  rows: Array<{
    imgUrl: string
    link: string
    priority: number
  }>
}

export function ShopModuleCarousel({
  jsonConfig,
}: {
  jsonConfig: CarouselCconfig
}) {
  if (!jsonConfig || !jsonConfig.rows || jsonConfig.rows.length === 0) {
    return null
  }

  const items = jsonConfig.rows.sort((a, b) => a.priority - b.priority)

  return (
    <div className="container">
      <div className="carousel-wrap">
        <Carousel
          autoplay={true}
          autoplaySpeed={5000}
          swipeToSlide={true}
          draggable={true}
          infinite={true}
          useTransform={false}
          pauseOnDotsHover={true}
        >
          {items.map((row, index) => (
            <div key={index}>
              {row.link ? (
                // eslint-disable-next-line react/jsx-no-target-blank
                <a
                  key={index}
                  className="banner-wrapper"
                  href={row.link}
                  target={row.link?.startsWith("/") ? "_top" : "_blank"}
                >
                  {row.imgUrl.endsWith(".mp4") ? (
                    <BannerVideo videoUrl={row.imgUrl} />
                  ) : (
                    <BannerImg imgUrl={row.imgUrl} />
                  )}
                </a>
              ) : row.imgUrl.endsWith(".mp4") ? (
                <BannerVideo videoUrl={row.imgUrl} />
              ) : (
                <BannerImg imgUrl={row.imgUrl} />
              )}
            </div>
          ))}
        </Carousel>
      </div>
      <style jsx>{`
        .container {
          height: 480px;
          position: relative;
          user-select: none;
        }

        .carousel-wrap {
          height: 100%;
        }

        .carousel-wrap :global(.banner-img, .banner-video) {
          height: 480px;
          width: 100%;
          object-fit: cover;
        }

        .banner {
          height: 480px;
          width: 100%;
        }

        .banner {
          background-repeat: no-repeat;
          background-size: 1920px 480px;
          background-position: center center;
        }
      `}</style>
    </div>
  )
}

export function BannerImg({ imgUrl }: { imgUrl: string }) {
  const { getPublicUrl } = useUrl()
  return <img className="banner-img" src={getPublicUrl(imgUrl)} alt="banner" />
}

export function BannerVideo({ videoUrl }: { videoUrl: string }) {
  const { getPublicUrl } = useUrl()
  return (
    <video
      className="banner-video"
      autoPlay
      muted
      loop={true}
      poster={null}
      src={getPublicUrl(videoUrl)}
    />
  )
}
